import axios from 'axios'
import {
  PART_CREATE_REQUEST,
  PART_CREATE_SUCCESS,
  PART_CREATE_FAIL,
  PART_LIST_REQUEST,
  PART_LIST_SUCCESS,
  PART_LIST_FAIL,
  PART_DETAILS_REQUEST,
  PART_DETAILS_SUCCESS,
  PART_DETAILS_FAIL,
  PART_UPDATE_REQUEST,
  PART_UPDATE_SUCCESS,
  PART_UPDATE_FAIL,
  PART_DELETE_REQUEST,
  PART_DELETE_SUCCESS,
  PART_DELETE_FAIL,
} from '../constants/partConstants'

export const createPart = (part) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PART_CREATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(`/api/parts`, part, config)

    dispatch({
      type: PART_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PART_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getPartsByUserId = (user) => async (dispatch, getState) => {
  try {
    dispatch({ type: PART_LIST_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      params: {
        user,
      },
    }

    const { data } = await axios.get(`/api/parts/list`, config)

    dispatch({
      type: PART_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PART_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getPartDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PART_DETAILS_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`/api/parts/details/${id}`, config)

    dispatch({
      type: PART_DETAILS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PART_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updatePart = (part) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PART_UPDATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`/api/parts/${part._id}`, part, config)

    dispatch({
      type: PART_UPDATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: PART_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deletePart = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PART_DELETE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(`/api/parts/${id}`, config)

    dispatch({ type: PART_DELETE_SUCCESS })
  } catch (error) {
    dispatch({
      type: PART_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
